module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARBAMAAAAf5oCsAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5QTFRFAAAAE0idE0idE0idE0idE0idE0idE0idE0idE0idLPbj6AAAAAp0Uk5TAH9+/3x7enl4B6OUtOAAAABESURBVHicY2BgYBBkAAMmYwUw7WxsAqJYjY2NA4B0MpA2Y2BgNwaBAoZmMG3BMBMCGGAAxofJw9TD9MPNg5kPtw9sPwCbgRUfc5USvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_copy.png
// module id = 758b
// module chunks = 16